/* eslint-disable jsx-a11y/heading-has-content */
import React, { useState, useEffect, Fragment } from "react";
import classes_img from "../../assets/images/classs-img.png";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { StudentDashboardSidebar } from "../../components/StudentDashboardSidebar";
import StudentNavbar from "../../components/StudentNavbar";
import { allClasses } from "../../Store/api/activities";

const StudentClasses = () => {
  const dispach = useDispatch();
  const navigate = useNavigate();
  const [dueClasses, setDueClasses] = useState([]);
  const [, setSideBarEvent] = useState("overview");
  const [gotoSubject, setGotoSubject] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [classesLoader, setClassesLoader] = useState(false);

  useEffect(() => {
    setClassesLoader(true);
    setIsLoading(true);
    dispach(
      allClasses({
        onSuccess: (res) => {
          setDueClasses(res?.data);

          setClassesLoader(false);
          setIsLoading(false);
        },
        onError: (err) => {
          setClassesLoader(false);
          setIsLoading(false);
        },
      })
    );
  }, []);
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Ensure today has no time component

  const currentClasses = dueClasses?.filter((duClass) => {
    const startDate = new Date(duClass.startDate);
    const endDate = new Date(duClass.endDate);

    startDate.setHours(0, 0, 0, 0); // Normalize start date
    endDate.setHours(0, 0, 0, 0); // Normalize end date
    // Current classes: Start date <= today && End date >= today
    return endDate > today;
  });

  const previousClasses = dueClasses?.filter((duClass) => {
    const endDate = new Date(duClass.endDate);
    const startDate = new Date(duClass.startDate);
    endDate.setHours(0, 0, 0, 0);

    // Previous classes: End date < today
    return startDate < today;
  });

  /* Previous Date Format: Spring 2022 */
  const formatDate = (previousClasses) => {
    const date = new Date(previousClasses);
    const month = date.getMonth();
    let season = "";

    if (month >= 1 && month <= 6) {
      season = "spring";
    } else if (month >= 8 && month <= 12) {
      season = "fall";
    }
    const year = date.getFullYear();
    return `${season} ${year}`;
  }

  return (
    <div className="wrapper">
      {/* <!-- Page Sidebar --> */}
      <StudentDashboardSidebar
        sideBarEvent={"classes"}
        setSideBarEvent={setSideBarEvent}
        setGotoSubject={setGotoSubject}
      />
      {/* <!-- Page Content Holder --> */}
      <div id="content">
        <div className="content_dashborad_inner">
          {/* <!-- navbar --> */}
          <StudentNavbar
            sideBarEvent={"classes"}
            setSideBarEvent={setSideBarEvent}
          />
          {gotoSubject === 1 && (
            <div>
              <div className="main_section_content ">
                <div
                  className="center_content full_width"
                  style={{
                    justifyContent: "space-between",
                    marginRight: "2px",
                  }}
                >
                  <div>
                    <h1 className="ft_18 mb_24 margn_top cursor_default">
                      CURRENT CLASSES
                    </h1>

                    {/* {classesLoader ? (
                      "Loading..."
                    ) : ( */}
                    {currentClasses.length > 0 ? (
                      <div
                        className="wrap_books"
                        style={{ paddingBottom: "0px" }}
                      >
                        <div className="class-list-skeleton ">
                          {isLoading ? (
                            <h4
                              className="heading-skeleton m-0"
                              style={{ height: "427px", width: "609px" }}
                            ></h4>
                          ) : (
                            <>
                              {currentClasses.map((duClasss, index) => (
                                <div
                                  key={index}
                                  className="current_book cursor w-100"
                                >
                                  <div className="books_ar_shwd book_width">
                                    <img
                                      src={
                                        duClasss?.book?.coverImage ||
                                        duClasss?.book?.classesBookCoverUrl ||
                                        classes_img
                                      }
                                      alt="img"
                                      onClick={() => {
                                        navigate(
                                          `/studentdashboard/classes/class/${duClasss._id}`
                                        );
                                      }}
                                    />
                                  </div>
                                  <div
                                    // style={{width: "100%", padding: "8px"}}
                                    className="current_class_content  "
                                  >
                                    <h5 className="ft_14 fw-500 grey_900">
                                      {duClasss.courseName}
                                    </h5>
                                    <h5
                                      className="ft_14 fw-500 grey_900"
                                      style={{ marginBottom: "0px" }}
                                    >
                                      with
                                      {` ${duClasss.instructor.firstName} ${duClasss.instructor.lastName}`}
                                    </h5>
                                  </div>
                                </div>
                              ))}
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div
                        className="wrap_books"
                        style={{
                          paddingBottom: "0px",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "496px",
                        }}
                      >
                        <div
                          style={{ justifyContent: "center", display: "flex" }}
                        >
                          <span className="no-activity">
                            Not enrolled in any classes
                          </span>
                        </div>
                      </div>
                    )}
                    {/* )} */}
                  </div>
                  <div className="line-claass"></div>
                  <div>
                    <h1 className="ft_18 mb_24 ft_18 cursor_default">
                      PREVIOUS CLASSES
                    </h1>
                    <div
                      className="wrap_books wrap_books_previous cursor"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "32px",
                        justifyContent: "flex-start",
                      }}
                    >
                      {classesLoader ? (
                        "Loading..."
                      ) : (
                        <Fragment>
                          {previousClasses.map((item, index) => (
                            <div key={index} className="previous_book">
                              <div className="books_ar_shwd book_width">
                                <img
                                  src={
                                    item?.book?.coverImage ||
                                    item?.book?.classesBookCoverUrl ||
                                    classes_img
                                  }
                                  alt="img"
                                  onClick={() => {
                                    navigate(
                                      `/studentdashboard/classes/class/${item._id}`
                                    );
                                  }}
                                />
                              </div>
                              <div
                                className="previous_class_content  "
                                style={{ width: "100%", padding: "8px" }}
                              >
                                <h5 className="ft_14 fw-500 font_12 grey_900">
                                  {item.courseName}
                                </h5>
                                <h5 className="ft_14 fw-500 font_12 grey_900">
                                  {formatDate(new Date(item.endDate))}
                                </h5>
                              </div>
                            </div>
                          ))}{" "}
                        </Fragment>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default StudentClasses;
